import {
  AspectRatio,
  Box,
  HStack,
  VStack,
  Image,
  Skeleton,
  Stack,
  useBreakpointValue,
  useMediaQuery,
} from '@chakra-ui/react';
import * as React from 'react';
// import { IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5'
import { AiFillCaretLeft, AiFillCaretRight } from 'react-icons/ai';
import { AiFillCaretUp, AiFillCaretDown } from 'react-icons/ai';
import {
  Carousel,
  CarouselIconButton,
  CarouselSlide,
  useCarousel,
} from './Carousel';

export const Gallery = props => {
  const { images, aspectRatio = 4 / 3, rootProps } = props;
  const [index, setIndex] = React.useState(0);
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  const slidesPerView = useBreakpointValue({
    base: 3,
    md: 5,
  });

  
  const thumbnailsRef = React.useRef(null);

  // Function to scroll thumbnails
  const scrollThumbnails = (direction) => {
    if (thumbnailsRef.current) {
      thumbnailsRef.current.scrollBy({
        top: direction === 'up' ? -150 : 150, // Scroll by 150px
        behavior: 'smooth', // Smooth scrolling
      });
    }
  };


  const [ref, slider] = useCarousel({
    vertical: true, // Enable vertical scrolling
    slides: {
      perView: slidesPerView,
      spacing: 10,
      
    },
    slideChanged: slider => setCurrentSlide(slider.track.details.rel),
  });
  return (
    <HStack spacing="4" align="start" {...rootProps}>
    {/* Left Side: Thumbnail Carousel */}
    {images.length > 0 && (
      <VStack spacing="3" align="center" height="400px" overflow="hidden">
        {/* Up Arrow for Scrolling */}
        <CarouselIconButton
          onClick={() => scrollThumbnails('up')}
          icon={<AiFillCaretUp />}
          aria-label="Scroll Up"
        />

        <Box width="150px" height="400px" overflow="hidden" ref={thumbnailsRef}>
          <VStack spacing="2">
            {images.map((media, i) => (
              <Box
                key={i}
                width="80px"
                height="80px"
                cursor="pointer"
                onClick={() => setIndex(i)}
                border={index === i ? '2px solid #3182ce' : '2px solid transparent'}
                borderRadius="10px"
                transition="transform 0.2s ease-in-out"
                _hover={{ transform: 'scale(1.05)' }}
              >
                <Image
                  src={media.src}
                  objectFit="cover"
                  alt={media.alt || 'Media'}
                  fallback={<Skeleton />}
                  width="100%"
                  height="100%"
                />
              </Box>
            ))}
          </VStack>
        </Box>

        {/* Down Arrow for Scrolling */}
        <CarouselIconButton
          onClick={() => scrollThumbnails('down')}
          icon={<AiFillCaretDown />}
          aria-label="Scroll Down"
        />
      </VStack>
    )}

    {/* Right Side: Main Image Display */}
    {images.length > 0 && (
      <AspectRatio ratio={aspectRatio} flex="1">
        <Image
          className="Ecomm-Image"
          src={images[index].src}
          objectFit="contain"
          alt={images[index].alt}
          fallback={<Skeleton />}
        />
      </AspectRatio>
    )}

    <style>
      {`
        .Ecomm-Image {
            object-fit: contain !important;
        }
      `}
    </style>
  </HStack>
  );
};
